module.exports = __webpack_public_path__ + "img/test_r21.2f0980ba.png";